var sprintf = require('sprintf-js').sprintf;

function format(amount, symbol) {
    if (amount < 0) {
        return "(" + format(amount * -1) + ")";
    }

    symbol = typeof symbol === "undefined" ? '$' : symbol;

    return sprintf("%s%.2f", symbol, amount);
}

module.exports = { format };



// WEBPACK FOOTER //
// ./app/util/Currency.js